import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import styles from './VideosFilter.module.scss';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../components/Icon/Icon';

const VideosFilter = ({ selectedItem, data, onClick }) => {
  const [isActive, setIsActive] = useState(false);

  const selectRef = useRef(null);
  const optionsRef = useRef(null);

  const { t } = useTranslation();

  const handleToggle = () => {
    setIsActive(!isActive);
  };

  const handleClick = value => {
    onClick(value);
    setIsActive(false);
  };

  const handleClose = event => {
    if (optionsRef.current && !optionsRef.current.contains(event.target) && !selectRef.current.contains(event.target)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClose, true);
    return () => {
      document.removeEventListener('click', handleClose, true);
    };
  }, []);

  return (
    <>
      <div ref={selectRef} className={styles.selectMain} onClick={handleToggle}>
        <span>{t(selectedItem.DESCRIPTION)}</span>
        <Icon src="showHideArrow" className={cx(styles.arrowButton, { [styles.turn]: isActive })} />
      </div>
      {isActive && (
        <div ref={optionsRef} className={styles.selectOptionsContainer}>
          {Object.values(data).map(({ TYPE, DESCRIPTION }) => (
            <div
              key={TYPE}
              className={cx(styles.selectOption, { [styles.selectNotSelected]: TYPE !== selectedItem.TYPE })}
              onClick={() => handleClick({ TYPE, DESCRIPTION })}
            >
              <Icon src="check" />
              <span>{t(DESCRIPTION)}</span>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default VideosFilter;
